





import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseImage from "@/components/BaseImage";

export default defineComponent({
  name: "MediaImageView",
  components: { BaseIcon, BaseImage },
  props: {
    src: { type: String },
    icon: { type: String, default: "sci-image" },
  },
});
